import React, { useState } from "react";
import './css/arent.css';
import './css/bootstrap.min.css';
import './css/bootstrap.min.css.map';
import './css/font-awesome.min.css';
import './css/magnific-popup.css';
import './css/owl.carousel.css';
import './css/owl.theme.css';
import './css/tooplate-style.css';

import './fonts/fontawesome-webfont.eot';
import './fonts/fontawesome-webfont.svg';
import './fonts/fontawesome-webfont.ttf';
import './fonts/fontawesome-webfont.woff';
import './fonts/fontawesome-webfont.woff2';
import './fonts/FontAwesome.otf';
import './fonts/glyphicons-halflings-regular.eot';
import './fonts/glyphicons-halflings-regular.ttf';
import './fonts/glyphicons-halflings-regular.woff';
import './fonts/glyphicons-halflings-regular.woff2';

import Logo from './images/trans-logo.png';
import Transporter from './images/transporter.jpeg';
import HellTransporter from './images/hell-transporter.jpeg';

import Boxer from './images/Boxer.png';
import Fiat from './images/Fiat.png';


import './js/custom.js';

function App() {

     const [isCollapsed, setIsCollapsed] = useState(false);

     const toggleNavbar = () => {
          setIsCollapsed(prev => !prev);
     };

     const [formData, setFormData] = useState({
          name: "",
          email: "",
          subject: "",
          message: "",
     });

     const handleChange = (e) => {
          setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
          };

          const handleSubmit = async (e) => {
          e.preventDefault();
          const res = await fetch("https://arent.info/sendMail.php", {
               method: "POST",
               headers: { "Content-Type": "application/json" },
               body: JSON.stringify(formData),
          });

          const data = await res.json();
          if (data.success) {
               alert("Mail wurde erfolgreich gesendet 💌");
          } else {
               alert("Fehler beim Senden 😢");
          }
     };

     const onSubmit = async (e) => {
          e.preventDefault();

          try {
          const response = await fetch("https://arent.info/sendMail.php", {
               method: "POST",
               headers: { "Content-Type": "application/json" },
               body: JSON.stringify(formData)
          });

          const text = await response.text();
          const data = JSON.parse(text);

          if (data.success) {
               alert("Deine Nachricht wurde verschickt! 💌");
          } else {
               alert("Fehler: " + (data.error || "Unbekannt"));
          }
          } catch (err) {
          console.error(err);
          alert("Ups! Da ging was schief.");
          }
          };


  return (
    <div className="App">

<div className="navbar custom-navbar navbar-fixed-top" role="navigation">
     <div className="container">

          <div className="navbar-header">
               <button className="navbar-toggle" onClick={toggleNavbar} data-toggle="collapse" data-target=".navbar-collapse">
                    <span className="icon icon-bar"></span>
                    <span className="icon icon-bar"></span>
                    <span className="icon icon-bar"></span>
               </button>
         
               <a href="index.html" className="navbar-brand">
                    <img className="logo" src={Logo} alt="Image"></img> 
               </a>
          </div>


          <div className={`collapse navbar-collapse ${isCollapsed ? "show" : ""}`}>
               <ul className="nav navbar-nav navbar-right">
                    <li><a href="#home" className="smoothScroll" onClick={toggleNavbar} >Home</a></li>
                    <li><a href="#about" className="smoothScroll" onClick={toggleNavbar}>Über uns</a></li>
                    <li><a href="#transporter" className="smoothScroll" onClick={toggleNavbar}>Transporter</a></li>  
                    <li><a href="#contact" className="smoothScroll" onClick={toggleNavbar}>Kontakt</a></li>
               </ul>
          </div>

     </div>
</div>



<section id="home" className="parallax-section">
     <div className="overlay"></div>
     <div className="container">
          <div className="row">

               <div className="col-md-8 col-sm-12">
                    <div className="home-text">
                         <h1>Willkommen bei <br></br> A-RENT!</h1>
                         <div className='subtext'>Ihr Partner für Transporterverleih, auch für junge Fahrer ab 18 Jahre
</div>
                         <ul className="section-btn">
                              <a href="#contact" className="smoothScroll"><span data-hover="Discover More">Verfügbarkeit prüfen</span></a>
                         </ul>
                    </div>
               </div>

          </div>
     </div>
  <img className="main-image" src={HellTransporter} alt="Image"></img> 
</section>


<section id="about" className="parallax-section">
     <div className="container">
          <div className="row">

               <div className="col-md-offset-1 col-md-10 col-sm-12">
                    <div className="about-info">
                         <h1>Wilkommen zu A-RENT Transportervermietung</h1>
                         <h4>Sie suchen einen zuverlässigen Transporter oder einen Autotransporter für Ihren Umzug, einen geschäftlichen Transport oder den sicheren Fahrzeugtransport? Dann sind Sie bei uns genau richtig!
          <div><strong>A-RENT</strong> bietet Ihnen eine moderne und gut gewartete Fahrzeugflotte, mit der Sie Ihre Transporte einfach und flexibel gestalten können.</div>
          <br></br></h4>

          <h1> Warum A-RENT?</h1>

<h4><div><strong>Vielfältige Auswahl:</strong>Transporter und Autotransporter für jeden Bedarf</div> 

<div><strong>Faire Preise:</strong> Transparente Mietpreise ohne versteckte Kosten</div>

<div><strong>Flexibilität:</strong> Kurz- und Langzeitmieten möglich</div>

<div><strong>Altersbegrenzung:</strong> Fahrer ab 18 Jahre</div>

<div><strong>Sicherheit & Komfort:</strong> Regelmäßig gewartete Fahrzeuge für eine sorgenfreie Fahrzeugtransport</div>
<br></br>
Reservieren Sie jetzt Ihr Wunschtransporter und profitieren Sie von unserem erstklassigen Service! Wir freuen uns darauf, Sie bei <strong>A-RENT</strong> willkommen zu heißen!</h4>
                    </div>
               </div>

          </div>
     </div>
</section>

<section id="transporter" className="parallax-section">
     <div className="container">
          <div className="row">

               <div className="col-md-offset-2 col-md-8 col-sm-12">
                
                    <div className="section-title">
                         <h1>Transporter und Preise</h1>
                    </div>
               </div>

               <div className="clearfix"></div>

               <div id="owl-team" className="owl-carousel">
                    <div className="col-md-4 col-sm-4 item">
                         <div className="team-item">
                              <img src={Boxer} className="img-responsive" alt=""/>
                              <div className="team-overlay">
                                   <ul className="social-icon">
                                        
                                   </ul>
                              </div>
                         </div>
                         <h3>Peugeot Boxer</h3>
                         <p>zulässiges Gesamtgewicht bis 3,5t</p>
                         <p>80€ / 4 Stunden inkl. 200km</p>
                         <p>150€ / 1 Tag inkl. 400km</p>
                    </div>

                    <div className="col-md-4 col-sm-4 item">
                         <div className="team-item">
                              <img src={Fiat} className="img-responsive" alt=""/>
                              <div className="team-overlay">
                                   <ul className="social-icon">
                                        
                                   </ul>
                              </div>
                         </div>
                         <h3>Fiat</h3>
                         <p>zulässiges Gesamtgewicht bis 3,5t</p>
                         <p>80€ / 4 Stunden inkl. 200km</p>
                         <p>150€ / 1 Tag inkl. 400km</p>
                    </div>

               </div>

          </div>
     </div>
</section>


<section id="contact" className="parallax-section">
     <div className="container">
          <div className="row">

               <div className="col-md-offset-3 col-md-6 col-sm-12">
                    <div className="section-title">
                         <h1>Transporter-Buchungsanfrage</h1>
                         <p>Stelle hier eine unverbindliche Anfrage und wir melden uns umgehend bei dir zur Transporter-Verfügbarkeit!</p>
                    </div>
               </div>

               <div className="clearfix"></div>

               <div className="col-md-offset-2 col-md-8 col-sm-12">

                    <form id="contact-form" action="#" method="get" role="form" onSubmit={onSubmit}>


                         <h6 className="text-success">Your message has been sent successfully. </h6>
                         
                         <h6 className="text-danger">E-mail must be valid and message must be longer than 1 character.</h6>

                         <div className="col-md-6 col-sm-6">
                              <input type="text" className="form-control" onChange={handleChange} id="cf-name" name="cf-name" placeholder="Vorname u. Nachname"/>
                         </div>

                         <div className="col-md-6 col-sm-6">
                              <input type="email" className="form-control" onChange={handleChange} id="cf-email" name="cf-email" placeholder="Email Addresse"/>
                         </div>

                         <div className="col-md-12 col-sm-12">
                              <p>Bitte geben Sie einen Wunschtermin ein:</p>
                              <input type="date" className="form-control" onChange={handleChange}
                                   id="cf-subject" name="subject" value={formData.subject} placeholder="Wunschtermin auswählen"/>
                              <textarea className="form-control" rows="5" onChange={handleChange} id="cf-message" name="cf-message" placeholder="Nachricht"></textarea>
                         </div>

                         <div className="col-md-offset-4 col-md-4 col-sm-offset-4 col-sm-4">
                              <div className="section-btn">
                                   <button type="submit" className="form-control" id="cf-submit" name="submit"><span data-hover="Send Message">anfragen</span></button>
                              </div>
                         </div>
                    </form>
               </div>

          </div>
     </div>
</section>

<footer>
     <div className="container">
          <div className="row">

               <div className="col-md-5 col-sm-6">
                    <h2>Inhaber</h2>
                    <p>A-Rent Fahrzeugvermietung</p>
                    <p>Mehmet Gökten u. Hasan Barak</p>
                    <p>Frankfurter Str. 15, 35236 Breidenbach</p>
                    
               </div>

               <div className="col-md-4 col-sm-6">
                    <div className="footer-info">
                    	<h2>Kontakt</h2>
                         <p>Anruf oder Whatsapp:</p>
                         <p><a href="tel:01703280476">unter 0170 3280476 </a></p>
                         <p><a href="tel:01755999701">auch 0175 5999701</a></p>
                         <p><a href="mailto:service@arent.info">service@arent.info</a></p>
                         <p><a href="#">Frankfurter Str. 15, 35236 Breidenbach</a></p>
                         <p><a href="#">Mo.-Sa.: 07:00-22:00 Uhr</a></p>
                    </div>
               </div>

               <div className="col-md-3 col-sm-12">
               		
                    <h2>A-RENT</h2>
                    <ul className="navbar-collapse">
                         <ul className="nav navbar-nav navbar-right">
                    <li><a href="#home" className="smoothScroll">Home</a></li>
                    <li><a href="#about" className="smoothScroll">Über uns</a></li>
                    <li><a href="#transporter" className="smoothScroll">Transporter</a></li>  
                    <li><a href="#contact" className="smoothScroll">Kontakt</a></li>
               </ul>
                    </ul>
                    
               </div>

               <div className="clearfix"></div>

               <div className="col-md-12 col-sm-12">
                    <div className="copyright-text">
                         <p>Copyright © 2025 A-RENT Fahrzeugvermietung
                         
                         </p>
                    </div>
               </div>
               
          </div>
     </div>
</footer>
        
    </div>
  );
}

export default App;
